import merge from 'lodash/merge'
import { omit } from 'lodash'

import { SET_ACTIVE_RESTAURANTS } from '../actions/setActiveRestaurants'
import { REMOVE_ACTIVE_RESTAURANTS } from '../actions/removeActiveRestaurants'

const initialState = {
}

export default function activeRestaurantsReducer(state = initialState, action) {
	switch(action.type) {

		case SET_ACTIVE_RESTAURANTS:
			return merge({}, state, action.payload)

		case REMOVE_ACTIVE_RESTAURANTS:
			return omit(state, action.payload)

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/activeRestaurantsReducers.js